import axios from "axios";
import { openFile, openBlankTab } from "../../../native/files";

const base = `${process.env.REACT_APP_BACKEND_URL}/vendor-contracts`;
const headers = () => ({ headers: { Authorization: "Bearer " + localStorage.getItem("token") } });

export const getMeta = () => axios.get(`${base}/meta`, headers());
export const listContracts = filters => axios.post(`${base}/list`, filters, headers());
export const getContract = id => axios.get(`${base}/${id}`, headers());
export const createContract = body => axios.post(base, body, headers());
export const updateContract = (id, body) => axios.put(`${base}/${id}`, body, headers());
export const deleteContract = id => axios.delete(`${base}/${id}`, headers());
export const reextractContract = (id, language) =>
  axios.post(`${base}/${id}/extract`, { language }, headers());

export const uploadContract = (files, language) => {
  const body = new FormData();
  files.forEach(file => body.append("files", file, file.name));
  body.append("language", language);
  return axios.post(`${base}/extract`, body, headers());
};

/** Opens an uploaded file in a new tab (it needs the auth header, so no plain link). */
export const openDocument = async (contractId, documentId) => {
  // Opened before the request, or the browser treats it as a popup.
  const tab = openBlankTab();
  try {
    const res = await axios.get(`${base}/${contractId}/documents/${documentId}`, {
      ...headers(),
      responseType: "blob"
    });
    await openFile(res.data, { tab });
  } catch (err) {
    tab?.close();
    throw err;
  }
};
